import { Button, Flex } from '@aws-amplify/ui-react';
import General from '../utils/GeneralUtils';

interface TokenPaginationProps {
  /** The page shown, from 1. */
  page: number;
  pageSize: number;
  /** How many items this page holds. */
  shown: number;
  /** How many items match, over every page; unknown leaves the range without "of". */
  total?: number;
  hasNext: boolean;
  isLoading?: boolean;
  onPrevious: () => void;
  onNext: () => void;
  /** No margins, for a toolbar that spaces its own items (the export review's bottom bar). */
  inline?: boolean;
}

/**
 * Previous and next for a token-paged list, with the range shown ("26–50 of 18,432"). The Go API
 * pages by token, so there is no jumping to page N. Hidden when everything fits on one page.
 */
export function TokenPagination({
  page,
  pageSize,
  shown,
  total,
  hasNext,
  isLoading,
  onPrevious,
  onNext,
  inline,
}: TokenPaginationProps) {
  if (page <= 1 && !hasNext) return null;
  const from = (page - 1) * pageSize + 1;
  const to = (page - 1) * pageSize + shown;
  return (
    <Flex
      marginTop={inline ? 0 : 30}
      marginBottom={inline ? 0 : 50}
      justifyContent="flex-start"
      alignItems="center"
      gap={20}
    >
      <Button
        size="small"
        className="tiny"
        isDisabled={page <= 1 || isLoading}
        onClick={onPrevious}
      >
        ‹ Previous
      </Button>
      <span className="desc-2">
        {General.addCommasToNumber(from)}–{General.addCommasToNumber(to)}
        {total !== undefined && <> of {General.addCommasToNumber(total)}</>}
      </span>
      <Button size="small" className="tiny" isDisabled={!hasNext || isLoading} onClick={onNext}>
        Next ›
      </Button>
    </Flex>
  );
}
